import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {isNotEmpty, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {initialUser, Chat} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {useQueryResponse} from '../core/QueryResponseProvider'
import { PasswordMeterComponent } from '../../../../../../_metronic/assets/ts/components'
import { PrivateChat } from './SingleChat'

type Props = {
  isUserLoading: boolean
}



const ChatViewForm: FC<Props> = ({ isUserLoading}) => {
 return (
 <>
 <PrivateChat />
 </>);

}

export {ChatViewForm}
